/* Clear the loading indicator when playback actually resumes after buffering.
   The theme only listens to play/canplaythrough, which need not fire on resume. */
document.addEventListener('playing', (event) => {
  if (!(event.target instanceof HTMLVideoElement)) return;
  const player = event.target.closest('internal-video');
  if (player) player.classList.remove('internal-video--loading');
}, true);

/* Carousel posters are rendered as data-poster: a video poster is never lazy-loaded by
   the browser, so every slide's image used to download with the page. Show a section's
   posters once any of its videos comes near the viewport (all of them, so swiping never
   reveals a blank slide). */
(() => {
  const selector = 'internal-video video[data-poster]';
  function showPosters(root) {
    for (const video of root.querySelectorAll(selector)) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }
  }
  const connection = navigator.connection;
  if (!('IntersectionObserver' in window) || (connection && connection.saveData)) {
    showPosters(document);
    document.addEventListener('shopify:section:load', (event) => showPosters(event.target));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const section = entry.target.closest('.shopify-section') || entry.target.parentElement;
      for (const video of section.querySelectorAll(selector)) observer.unobserve(video);
      showPosters(section);
    }
  }, { rootMargin: '600px 0px', threshold: 0 });

  function observePosters(root) {
    for (const video of root.querySelectorAll(selector)) observer.observe(video);
  }
  observePosters(document);
  document.addEventListener('shopify:section:load', (event) => observePosters(event.target));
})();

/* Warm nearby carousel videos without starting playback or fetching distant slides. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const connection = navigator.connection;
  if (connection && connection.saveData) return;

  const observed = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const video = entry.target;
      observer.unobserve(video);
      // The theme owns playback. Never reload media that it has already started.
      if (video.currentSrc || !video.paused) continue;
      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) continue;
      for (const source of sources) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
      video.preload = 'metadata';
      video.load();
    }
  }, { rootMargin: '400px 0px', threshold: 0 });

  function observeVideos(root) {
    for (const video of root.querySelectorAll('internal-video[data-autoplay="true"] video')) {
      if (observed.has(video)) continue;
      observed.add(video);
      observer.observe(video);
    }
  }

  observeVideos(document);
  document.addEventListener('shopify:section:load', (event) => observeVideos(event.target));
})();
